module.exports = __webpack_public_path__ + "static/media/btn.cfe223ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/btn.png
// module id = 20
// module chunks = 0